// import { CircularProgress } from "@mui/material";
import _ from "lodash";
import moment from "moment";
import localStorageCall from "./localstorage.hook";
import { cleanPhoneNumber, storeAssigned } from "./normalMethods";
import { getCurrencyCode } from "./normalMethods";
import { _getStoreFrontId } from "./normalMethods";
export function _priceTypeForCalculate(section, autoshipProducts = []) {
    let priceType = 1;
    const CUSTOMER_TYPE_CHECKOUT = localStorageCall().getItem('customerTypeDescr');
    if (section === 'ambassador') {
        priceType = (autoshipProducts?.length > 0) ? 3 : 3;
    } else if (section === 'member' || section === 'main_enrollment') {
        priceType = (autoshipProducts?.length > 0) ? 2 : 2;
    } else if (section === 'VIP') {
        priceType = (autoshipProducts?.length > 0) ? 1 : 1;
    } else {
        if (_.includes(['VIP'], CUSTOMER_TYPE_CHECKOUT?.role)) {
            priceType = (autoshipProducts?.length > 0) ? 1 : 1;
        } else if (_.includes(['ambassador'], CUSTOMER_TYPE_CHECKOUT?.role)) {
            priceType = (autoshipProducts?.length > 0) ? 3 : 3;
        } else {
            priceType = (autoshipProducts?.length > 0) ? 2 : 2;
        }
    }

    return priceType;
}

function _commonCheckoutObj(userData, selectedCheck, byPass) {
    const PlanId = localStorageCall().getItem('partyPlanId');
    let PartyPlanId = PlanId ? { "partyPlanId": PlanId } : {};
    return ({
        customerId: localStorageCall().getItem('Token') || 0,
        priceType: userData?.priceType ? userData?.priceType : 1,
        storefrontId: +_getStoreFrontId('All Products') || 1,
        currencyCode: getCurrencyCode(userData?.shipping_country || _.upperCase(storeAssigned())),
        shipCarrierId: selectedCheck?.shipCarrierId || 0,
        shipMethodType: selectedCheck?.shipMethodType || 0,
        country: userData?.shipping_country,
        firstName: userData?.shipping_urname,
        lastName: userData?.shipping_lastname,
        address1: userData?.shipping_street,
        address2: userData?.shipping_street2,
        city: userData?.shipping_city,
        phone: userData?.shipping_phone?.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, ''),
        email: userData?.shipping_email || userData?.emailAddress,
        zip: userData?.shipping_zipcode,
        state: userData?.shipping_state,
        field1: userData?.shipping_delivery,
        field2: "",
        field3: "",
        field4: "",
        field5: "",
        field6: "",
        field7: "",
        field8: "",
        field9: "",
        field10: "",
        shipMethod: {
            "shipCarrierId": selectedCheck?.shipCarrierId || 0,
            "shipMethodType": selectedCheck?.shipMethodType || 0,
            "param1": "",
            "param2": "",
            "param3": "",
            "param4": "",
            "param5": ""
        },
        bypassAddressValidation: byPass,
        Payments: [],
        ...PartyPlanId,
    });
}

export const calculateDataUserPayload = (userData, selectedShippingOption, byPass, leadCustomerId) => ({
    // preAuthOrderId: 0,
    companyId: process.env.COMPANY_ID,
    customerId: localStorageCall().getItem('Token') || leadCustomerId || 0,
    company: userData?.shipping_company,
    orderType: 2,
    orderStatusType: 1,
    county: userData?.shipping_country,
    orderStatusSubType: 1,
    userName: userData?.shipping_email,
    // orderDate: moment.utc().format(),
    returnAllShipMethods: true,
    taxExemptOverride: true,
    couponCodes: [""],
    sessionId: "",
    ..._commonCheckoutObj(userData, selectedShippingOption['oneTimeSelectedShipping'], byPass)
});

export const calculateReouccringPayload = (userData, selectedShippingOption, byPass, leadCustomerId) => ({
    recurringOrderType: 1,
    recurringOrderStatusType: 1,
    customerId: localStorageCall().getItem('Token') || leadCustomerId || 0,
    frequencyType: 1,
    startDate: moment.utc().format(),
    endDate: moment().year(2030).utc().format(),
    paymentMethodId: 0,
    orderType: 1,
    orderStatusType: 2,
    company: userData?.shipping_company,
    priceCountryCode: userData?.shipping_country,
    shipToAddressType: 0,
    ..._commonCheckoutObj(userData, selectedShippingOption['autoshipSelectedShipping'], byPass)
});


export const _paymentPayload = (data, values, section = "normal", selectedPayment, paymentOption_ID) => {

    console.log("inside-the-paymentPayload-------------------------------------", paymentOption_ID?.paymentOptionTypeDescription)
    let payload = {
        "token": data?.id || null,
        "tokenType": 3,
        "phone": values?.shipping_phone?.replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, '') || "",
        "email": values?.shipping_email || "",
        // "currencyCode": "USD",
        "currencyCode": getCurrencyCode(_.upperCase(values?.shipping_country || storeAssigned())),
        "pointAccountType": 0,
        "country": values?.shipping_country || "",
        "state": values?.shipping_state || "",
        "city": values?.shipping_city || "",
        "address2": values?.shipping_street2 || "",
        "address1": values?.shipping_street || "",
        "lastName": values?.shipping_lastname || "",
        "firstName": values?.shipping_urname || "",
        "paymentType": 1,
        "zip": values?.shipping_zipcode || "",
        "saveToken": (section === 'normal' || paymentOption_ID?.paymentOptionTypeDescription === 'Redirect') ? true : true,
        ...!(selectedPayment?.cardValue && selectedPayment?.selectedOptionForPayment === 1)
            ?
            { "paymentOptionId": section === 'autoship' ? 0 : (selectedPayment?.selectedPaymentDropdown || selectedPayment?.cardValue?.accountType || 1) }
            :
            { "paymentOptionId": 0 }
    };

    const PAYMENT_PAYLOAD = (paymentOption_ID?.paymentOptionTypeDescription === 'iFrame') ? payload : (section !== "normal") ? payload : _.omit(payload, ['token', 'tokenType', 'paymentType']);

    return PAYMENT_PAYLOAD;
}

export const OuterLoader = ({ section, msg }) => (
    <div className='order-summary mb-[20px]' style={{ padding: "0" }}>
        {/* <h2>{section} Order Summary</h2> */}
        <div className='order-data loader_order text-center px-0 pt-[30px] pb-[10px] text-center'>
            <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-blue border-t-transparent m-[0_auto]"></div>
        </div>
        <p className="text-[18px] m-0 text-center pb-[10px]">{msg ? msg : 'Please complete your shipping information'}</p>
    </div>
);

export const CreateObject = (row) => ({
    id: row?.itemId || row?.id,
    productName: row?.description || row?.title,
    image: row?.field1 || row?.image,
    price: row?.itemPrice || row?.[`normal_${(row?.frequency === 'member' ? 'autoship' : row?.frequency)}`] || '0.00',
    quantity: row?.quantity || row?.quantity,
    itemCode: row?.fullItemCode || row?.itemCode,
});

export const CHECKBOX_CONDITIONS = [
    { name: "termscondition2", checkboxText: "I have read and accepted the", linkText: "Policies and procedures", link: "/pdf/PerfectlyPosh_Policies_and_Procedure.pdf" },
    { name: "privacy_policy", checkboxText: "I agree to the", linkText: "Privacy policy", link: "/assets/pdfs/YoungNRG_PrivacyPolicy.pdf" },
    { name: "membershipCharge", checkboxText: "I will be charged for my membership", linkText: "", link: "" },

];

export function _checkoutAddressFormat(userData, formData, useDefaultAddressOrNot, countryState) {
    return ({
        search_enroller: formData?.search_enroller || userData?.enrollerName || '',
        webAlias: formData?.webAlias || userData?.webAlias || '',
        shipping_urname: formData?.shipping_urname || userData?.firstName || '',
        shipping_lastname: formData?.shipping_lastname || userData?.lastName || '',
        shipping_email: formData?.shipping_email || userData?.emailAddress || "",
        shipping_phone: cleanPhoneNumber(formData?.shipping_phone) || cleanPhoneNumber(userData?.phoneNumbers?.cellPhone) || '',
        shipping_street: useDefaultAddressOrNot?.address_1 || formData?.shipping_street || userData?.shippingAddress?.address1 || '',
        shipping_street2: formData?.shipping_street2 || userData?.shippingAddress?.address2 || '',
        shipping_city: useDefaultAddressOrNot?.city || formData?.shipping_city || userData?.shippingAddress?.city || '',
        shipping_zipcode: useDefaultAddressOrNot?.postal_code || formData?.shipping_zipcode || userData?.shippingAddress?.postalCode || '',
        shipping_country: useDefaultAddressOrNot?.country || countryState?.country || formData?.shipping_country || userData?.countryCode || 'US',
        shipping_state: useDefaultAddressOrNot?.state_region || countryState?.state || formData?.shipping_state || userData?.shippingAddress?.regionProvState || '',
    })
}